<template>
  <div>
    <Breadcrumbs :breadcrumbs="breadcrumbs">
      <template slot="breadcrumbAfter">
        <va-dropdown
          v-if="canUpdatePatient"
          class="custom-dropdown"
          fixed>
          <span slot="anchor">
            <slot>
              <div class="pl-3 pr-2 clickable">
                <span class="fa fa-ellipsis-v" style="font-size: 1.5rem;"></span>
              </div>
            </slot>
          </span>
          <div class="contact-dropdown__content pl-3 pr-2 pt-2 pb-2">
            <div v-if="canUpdatePatient" class="contact-dropdown__item align--center clickable" @click.prevent="isUpdatingPatient = true">
              <i class="fa fa-pencil"></i>&nbsp;
              <span class="pl-2 clickable">{{$t('people.actions.edit')}}</span>
            </div>

          </div>
        </va-dropdown>
      </template>
    </Breadcrumbs>

    <div v-if="patient" class="mb-5">
      <PatientInfo
        class="my-3"
        :patient=patient
        :patientEntity="patientEntity"
      >
      </PatientInfo>

      <!-- Check up plus appointments -->
      <CheckupPlusAppointmentsList
        :patient="patient"
        :allowedEntities="allowedEntities"
      />

      <!-- -------------------------- -->
    </div>

    <CreateOrUpdatePatient
      v-if="isUpdatingPatient"
      :service="component.service"
      :serviceSlug="serviceSlug"
      :patient="patient"
      @patientUpdated="onPatientUpdated"
      @cancel="onCancelPatientUpdate"
    />
  </div>

</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import { PeopleManagerService } from '@/api/PeopleManagerService';
import PatientInfo from '@/components/people-manager/patient/PatientInfo.vue';
import CreateOrUpdatePatient from '@/components/people-manager/patient/CreateOrUpdatePatient.vue';
import CheckupPlusAppointmentsList from '@/components/people-manager/patient/CheckupPlusAppointmentsList.vue';

const PEOPLE_MANAGER_LIST_INFO_TYPE = 110

export default {
  components: { CheckupPlusAppointmentsList, CreateOrUpdatePatient, PatientInfo, Breadcrumbs },
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      patient: null,
      isUpdatingPatient: false,
    }
  },
  methods: {
    redirectBack: function () {
      this.$router.go(-1)
    },
    getPatient: async function(id) {
      try {
        this.patient = await PeopleManagerService.getPatient(id)
      } catch (err) {
        console.log(err)
        this.redirectBack()
      }
    },
    handlePatientName: function () {
      var str = ''
      if(this.patient && this.patient.firstName) {
        str += this.patient.firstName
        if (this.patient.lastName) {
          str += ' '+this.patient.lastName
        }
      }
      return str
    },
    onPatientUpdated: function(patientData) {
      this.patient = patientData
      this.isUpdatingPatient = false
    },
    onCancelPatientUpdate: function() {
      this.isUpdatingPatient = false
    }
  },
  computed: {
    breadcrumbs: function () {
      let items = [
        { title: this.$t(`menu.${this.serviceSlug}`), disabled: true },
        { title: this.$t('menu.people-manager/list'), meta: { type: 'function', value: () => {
              this.$router.push(`/${this.serviceSlug}/people-manager/list`)
            } } } // eslint-disable-line
      ]
      if (this.patient) {
        items.push({ title: this.handlePatientName(), active: true })
      }
      return items
    },
    peopleManagerService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.people_manager_server) || null
    },
    allowedEntities: function () {
      if (this.peopleManagerService) {
        if(this.peopleManagerService.user_permissions.length > 0) {
          const allowedEntitiesIds = this.peopleManagerService.user_permissions.filter(elem => elem.info_type === PEOPLE_MANAGER_LIST_INFO_TYPE).map(elem => elem.entity_id)
          if(allowedEntitiesIds.some(id => id === null)) {
            return this.peopleManagerService.entities
          } else {
            return this.peopleManagerService.entities.filter(entity => allowedEntitiesIds.includes(entity.id))
          }
        }
      }
      return []
    },
    patientEntity: function () {
      if(this.allowedEntities.length) {
        return this.allowedEntities.find(entity => entity.id === parseInt(this.patient.originEntityId)) || null
      }
      return null
    },
    canUpdatePatient: function () {
      return this.patient !== null && this.component.service.user_permissions.some(p => p.access_type >= 2 && p.info_type === PEOPLE_MANAGER_LIST_INFO_TYPE && (p.entity_id === null || p.entity_id === parseInt(this.patient.originEntityId)))
    },
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.id !== undefined) {
      next(vm => {
        vm.getPatient(parseInt(to.params.id))
        vm.from = from
      })
    } else {
      next(from)
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== undefined) {
      this.getPatient(parseInt(to.params.id))
    } else {
      next(from)
    }
  }
};
</script>

<style lang="scss">

.va-dropdown__content {
  left: -40px !important;
  top: -30px !important;
}

#person-details-page {
  .contact-dropdown__item {
    &:first-of-type {
      padding-top: 0.8rem !important;
      padding-bottom: 0.8rem !important;
      padding-left: 0.8rem !important;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    &:last-of-type {
      padding-top: 0.8rem !important;
      padding-bottom: 0.8rem !important;
      padding-left: 0.8rem !important;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    i {
      color: #29c4aa;
    }
    &:hover {
      background-color: #29c4aa;
      * {
        color: white;
      }
    }
  }
}

</style>
